module.exports = "/_next/static/images/LowRecencyPurchaseWinbackDesktop-22e3304258f9eff24fa9421a699e9bb0.webp";